// format closout date to 'Jan 06, 2023'....similar
export function formatDate(date: Date) {
  const formatter = Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: '2-digit',
    year: 'numeric'
  })
  return formatter.format(date)
}

/**
 * @param items Array
 * @param prop String property of array item to sum
 */
export function sumField(items : Array<any>, prop : any) {
  return items.reduce((a, b) => {
    return a + b[prop]
  }, 0)
}
